// @flow
import React from 'react';
import { Modal } from 'antd';
import { SpH5, SpButton } from 'components/DesignKit';

type Props = {
  visible: boolean,
  close: Function,
  submit: Function,
  selectedReport: Object,
};

const DeleteScheduleReport = (props: Props) => {
  const {
    visible,
    close,
    submit,
    selectedReport,
  } = props;

  const deleteScheduleReport = () => {
    submit(selectedReport && selectedReport.gid);
  };

  return (
    <Modal
      centered
      closable={false}
      visible={visible}
      footer={[
        <SpButton onClick={() => close()} type="secondary">Cancel</SpButton>,
        <SpButton onClick={deleteScheduleReport} type="danger">Delete</SpButton>,
      ]}
      title="Delete Schedule Report"
    >
      <div className="px-4">
        <div className="mt-1 mb-2">Are you sure you want to delete this Schedule Report?</div>
        <SpH5 className="pb-3">
          <div>{selectedReport && selectedReport.type}</div>
        </SpH5>
      </div>
    </Modal>
  );
};

// $FlowFixMe
export default DeleteScheduleReport;
